import { Box, TextField } from '@mui/material';
import { useContext } from 'react';
import { AppContext } from '../../context/AppContext';

import '../pages/aspirantes/aspirantes.css';
export default function PerfilForm(data) {
	const { user } = useContext(AppContext);
	const { perfil } = user;

	return (
		<Box
			component="form"
			sx={{
				'& .MuiTextField-root': { width: '80%' },
			}}
			noValidate
			autoComplete="off"
		>
			<div>
				<TextField label="Identidad" value={perfil['aspirante_id']} variant="standard" size="small" fullWidth />
				<TextField label="Nombres" value={perfil['nombres']} variant="standard" size="small" fullWidth />
				<TextField label="Apellidos" value={perfil['apellidos']} variant="standard" size="small" fullWidth />
				<TextField label="Sede" value={perfil['sede']} variant="standard" size="small" fullWidth />
				<TextField label="Sistema" value={perfil['centro']} variant="standard" size="small" fullWidth />
				<TextField
					label="Carrera a estudiar 1"
					value={perfil['carrestudio1']}
					variant="standard"
					size="small"
					fullWidth
				/>
				<TextField
					label="Carrera a estudiar 2"
					value={perfil['carrestudio2']}
					variant="standard"
					size="small"
					fullWidth
				/>
			</div>
		</Box>
	);
}
